/**
 * TrendChip — 등락률 칩 (SC-019 §2 심플 뷰 · 홈 전역 표기 규칙).
 *
 * ⚠ 색상은 **서구식**이다 — 상승 초록 / 하락 빨강.
 * IA·PRD §4.3 rev4 에서 확정됐고, 실제 색은 `--price-up` / `--price-down` 토큰이
 * 들고 있으므로 관례를 되돌리려면 `tokens.css` 한 곳만 고치면 된다.
 *
 * 색만으로 방향을 읽게 하지 않는다 — GraphUp/GraphDown 아이콘을 항상 함께 쓴다
 * (색각 이상 대응). 2026-08-14 에 ▲▼ 문자에서 아이콘으로 바꿨다.
 * 등락을 계산할 수 없는 신규 카드는 `null` 을 넘기면 '—' 로 표시된다(FN-048).
 */
import { useTranslation } from "react-i18next";
import { Text } from "@astryxdesign/core/Text";
import PriceDelta from "./PriceDelta";

interface TrendChipProps {
  /** 등락률(%). null = 계산 불가(신규 등) */
  value: number | null;
  /** 앞에 붙일 기간 라벨 (예: "30일") */
  label?: string;
  /**
   * 글자 크기. 기본은 `supporting`(12px) — 등락은 금액 옆에 붙는 **보조 수치**라
   * 금액과 같은 16px 이면 어느 쪽이 값인지 흐려진다 (2026-08-14, 홈 §1 기준).
   */
  type?: "label" | "supporting" | "body";
}

export default function TrendChip({ value, label, type = "supporting" }: TrendChipProps) {
  const { t } = useTranslation("card");

  if (value === null) {
    return <Text type={type} color="secondary">{label ? `${label} ` : ""}{t("price.trendUnknown")}</Text>;
  }

  // 표기·색은 PriceDelta 가 든다 — 여기는 null(등락 계산 불가) 처리만 남는다.
  return <PriceDelta value={value} format="percent" label={label} type={type} />;
}
